import React, { Component } from 'react'
import '../css/Feiyongxiangqing.css'
import { connect } from 'react-redux';
import {Picker, List,  ListView } from 'antd-mobile/lib';
import { hashHistory } from "react-router";
import { ztcgfuwufeimingxi} from '../../action/investmentAction';
import Util from '../../util.js';
var objArr;

class Feiyongxiangqing extends Component {
  constructor(props) {  
    super(props); 
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.state = {
      loadingFlag: false,
      dataSource:ds.cloneWithRows([]),
        pageIndex:1,
        pageSize:30,
      nomore:false,
      totalDataArr:[],
      businessType:"",
      fundCode:"",
    } 
  }

  componentWillMount(){
    objArr = [];
  }
  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    let { dispatch } = this.props;
    let _this = this;
    let data1 = {
      pageIndex:this.state.pageIndex,
      pageSize:this.state.pageSize,
      superFundCode:this.props.location.state.superFundCode,
        }
      dispatch(ztcgfuwufeimingxi(data1,this.callbackData.bind(this),_this))
  }
  callbackData(data){
    console.log(data)
    let totalDataArr = this.state.totalDataArr.concat(data.records);
    if(data.records.length !== 0){
      if(data.records.length < this.state.pageSize){
        this.setState({
          nomore:3,
          dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          pageIndex: this.state.pageIndex+1,
          loadingFlag:false,
          handleFlag:false,
          timeAll:false,
        })
      }else{
        this.setState({
          nomore:0,
          pageIndex: this.state.pageIndex+1,
          dataSource:this.state.dataSource.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          loadingFlag:false,
          handleFlag:false,
      timeAll:false,
        })
      }
    }else{
      this.setState({
        nomore:3,
        loadingFlag:false,
      timeAll:false,
      })
    }
  }
  timeFormat(date){
    let newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
    return newDate[0]
  }
  getSource = () => {
    let { dispatch} = this.props;
    let _this = this;
    let data = {
      pageIndex:this.state.pageIndex,
      pageSize:this.state.pageSize,
      superFundCode:this.props.location.state.superFundCode,
    }
      dispatch(ztcgfuwufeimingxi(data,this.callbackData.bind(this),_this))
  }
  renderFooter(){
    if(this.state.nomore === 3){
      if(this.state.totalDataArr.length === 0){
        return(
          <div style={{ height: 0, textAlign: 'center' }}>
          没有更多数据了
       </div>
        )
      }else{
        return (
          <div style={{height:0, textAlign: 'center' }}>
       </div>
        );
      }
    }else {
      return null;
    }
  }
  render() {
    let {suoyoufuwufei}=this.props.location.state
    return (
      <div id='body2'>
        <div className='fuwufei_bg'>
        <div className="NHeader_container">
        <div className="NHeader_wrap">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}> <img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">投顾服务费</div>
            <div className="NHeader_share">
            </div>
          </div>
        </div>
      </div>
              <div className='feiyongCard'>
                <div className='feiyongCardTop'>
                  <div className='feiyongCardTop1'>所有服务费(元)</div>
                  <div className='feiyongCardTop2'>{Util.thousandCount(suoyoufuwufei)}</div>
                </div>
              </div>
              <div className='feiyongCard2'>
                  <div className='feiYongCard2top'>
                    <div className='feiYongCard2topLeft'>服务费明细</div>
                  </div>
                  <ListView
            ref={el => this.lv = el}
            dataSource={this.state.dataSource}
            renderFooter={()=> this.renderFooter() }
            renderRow={(item, index)=>{
              objArr = [{createDate: ""}].concat(this.state.totalDataArr);
              return(
                <div key={index} className="feiyongCardbottom" >
                <div className="feiyongCardbottom1">
                <div className="feiyongCardbottomtop">
                <div className="feiyongCardbottomtop1">
                    {item.currentSuperFundAssets ? item.currentSuperFundAssets:"--"}
                </div>
                <div className="feiyongCardbottomtop2">
                  当日总资产（{item.feeDateStr ? this.timeFormat(item.feeDateStr):"--"}）
                </div>
                </div>
                <div className="feiyongCardbottom2">
                {Util.thousandCount4(item.dailyFee)}
                </div>
                </div>
             </div>
               
              )
            }}
            onEndReached={this.getSource}
            onEndReachedThreshold={0.1}
          />
              </div>
          </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
  return {
  }
}
export default connect(mapStateToProps)(Feiyongxiangqing);


// WEBPACK FOOTER //
// ./src/components/fundDetail/Feiyongxiangqing.js